import Konva from 'konva';
import { map } from 'rxjs/operators';

import { MapRenderProps } from './interfaces';

export const mapRender = (layer: Konva.Layer) =>
  map(
    ({
      startMs: startWindowMs, // TODO propagrate name change back into MapRenderProps
      stopMs: stopWindowMs, // TODO propagrate name change back into MapRenderProps
      width: windowWidth, // TODO propagrate name change back into MapRenderProps
      list,
      timeRange,
      height, // pass in actual row height so step level display correctly
    }: MapRenderProps) => {
      layer.destroyChildren();

      const multiplier = windowWidth / (stopWindowMs - startWindowMs); // converts timeMs to pixel coordinate

      for (const slice of list) {
        if (slice) {
          const [startTimeMs, stopTimeMs, details] = slice;
          const x = (startTimeMs - startWindowMs) * multiplier;
          const w = (stopTimeMs - startTimeMs) * multiplier;
          if (
            startTimeMs <= stopWindowMs &&
            stopTimeMs > startWindowMs &&
            w > 0
          ) {
            // slice must overlap window to render
            const fill = 'rgb(224, 171, 250)';

            const barHeight = Math.ceil(
              (height * (details?.blurLevel ?? 10)) / 10.0
            );

            // ------ draw full height rect

            if (details?.blurLevel !== 10) {
              const rect = new Konva.Rect({
                x,
                y: 0,
                width: w,
                height,

                fill,
                opacity: 0.6,
              });

              layer.add(rect);
            }

            // ------ add second rect to indicate blur level

            // const yOffset = MAX_HEIGHT / 2.0 - barHeight / 2.0; // center
            const yOffset = height - barHeight; // bottom
            const rect2 = new Konva.Rect({
              x,
              y: yOffset, // 0,
              width: w,
              height: barHeight,
              fill,
            });

            layer.add(rect2);
          }
        }
      }

      // blue highlight for selected span
      const startTimeMs = timeRange[0];
      const stopTimeMs = timeRange[1];
      const x = startTimeMs * multiplier - startWindowMs * multiplier;
      const w = (stopTimeMs - startTimeMs) * multiplier;
      if (startTimeMs <= stopWindowMs && stopTimeMs > startWindowMs && w > 0) {
        const rect = new Konva.Rect({
          x,
          y: 0,
          width: w,
          height,
          fill: 'rgb(74, 144, 226)',
          opacity: 0.9,
        });
        layer.add(rect);
      }

      return layer;
    }
  );
